import React, { useState, useEffect } from 'react'
import { StyledMain } from './index.styled'
import { MenuExpansiveGroup } from '../../';
import { AerialView } from './../expansive/index.styled'
import { CgArrowLongLeft } from 'react-icons/cg'
import { DroneIcon } from '../../icons';
import {  setCurrentMap } from './../../../effects/actions'
import { FormattedMessage } from 'react-intl';
const menuMap = require('../../../assets/mock-data/menu-map.json')


const MenuExpansiveMapComponent = ({ currentSite, expandAll = true, onClickMenu = () => {}, currentMap = null}) => {
  const [ menu, setMenuState ] = useState([]);
  const [ groupActive, setGroupActive ] = useState(null);
  const [ subActive, setSubActive ] = useState(null);
  const [ setted, setSetted ] = useState(false);

  const getGroup = () => {
    let temp = menu.find((x) => {
      if(x.buttons && x.buttons.length > 0){
        return x.buttons.find(y => y.id === currentMap)
      }else{
        return x.id === currentMap
      }
    })
    return temp
  }
  useEffect(() => {
    if(currentMap !== null && menu !== [] && groupActive === null && setted === false){ 
      let temp = getGroup()
      if(temp){
        activeMenu(temp)
        setSetted(true)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMap, groupActive, menu])

  useEffect(() => {
    if(currentMap && menu !== [] && groupActive !== null && subActive === null){
      let temp = getGroup()
      if(temp && temp.buttons){
        let tempSub = temp.buttons.find(x => x.id === currentMap)
        setSubActive && setSubActive(tempSub?.id)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMap, groupActive, subActive, menu])

  const activeMenu = (selected) => {
    if(['contacts', 'entrance', 'cork-benefits', 'raw-material'].includes(selected.id)){
      setGroupActive(selected.id); 
      if(setted) onClickMenu(selected)
      return;
    }
    if(expandAll) {
      const oldMenu = [...menu];
      const choosed = oldMenu.findIndex(item => item.id === selected.id);
      oldMenu[choosed].active = !oldMenu[choosed].active;
      onClickMenu(selected)
      setMenuState(oldMenu);
    } else {
      const oldMenu = [...menu];
      const choosed = oldMenu.map(item => {
        if(item.id === selected.id ) item.active = !item.active;
        else item.active = false;
        return item;
      })

      onClickMenu(selected)
      setMenuState(choosed);
    }
  }

  // const setCurrentPage = (item) => {
  //   store.dispatch(setCurrentMap(item?.id))
  // }

  const getMenuItems = (site) => {
    return menuMap.filter(x => x.availableOn.includes(site))
  }

  useEffect(() => {
    const menu = getMenuItems(currentSite).filter(x => x.showOnMenu !== false).map((item) => ({
      id: item.id,
      title: item.title,
      subtitle: item.subtitle ? item.subtitle : '',
      buttons: item.items?.map((x) => ({
        id: x.id,
        pano: x.pano,
        title: x.title,
        active: false
      })),
      redirect: item.pano,
      active: false
    }))

    setMenuState(menu);
  }, [currentSite])

  return (
    <StyledMain>
      {currentSite === "factory" && (
        <AerialView onClick={() => {
          setCurrentMap("arl")
        }}>
          <CgArrowLongLeft />
          <DroneIcon />
          <FormattedMessage id="label.aerial-view" />
        </AerialView>
      )}
      { menu.map(item => (
          <MenuExpansiveGroup 
            icontype="arrow"
            key={item.id} 
            activeGroup={groupActive}
            activeSub={subActive}
            info={item}
            className={(item.id === groupActive && item?.buttons === undefined)? 'divisor active' : 'divisor'}
            clickHandler={() => activeMenu(item)} 
            clickSubmenuHandler={(item) => { 
              if(["wicanders", "wise"].includes(currentSite)){
                onClickMenu(item)
              }else{
                onClickMenu(item)
                //setCurrentPage(item)
              }
            }}
          />
        ))
      }        
    </StyledMain>
  )
}


export default MenuExpansiveMapComponent;
